export const BrandBar = () => (
  <div
    className="fixed top-0 inset-x-0 z-[60] h-9 bg-[#EDF4FB] border-b border-white/[0.08] flex items-center justify-center px-4"
    data-testid="brand-bar"
  >
    <p className="text-[10px] sm:text-[11px] font-mono uppercase tracking-[0.18em] text-muted-foreground/70 whitespace-nowrap overflow-hidden text-ellipsis">
      A Christopher Love platform
      <span className="text-sky-600 mx-1.5">·</span>
      <span className="text-slate-900">OPERA360</span>
      <span className="text-sky-600 mx-1.5">·</span>
      <a
        href="https://www.scopeonewalk.com"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="brand-bar-scopeone-link"
        className="text-green-700 hover:text-white transition-colors"
      >
        ScopeOne Walk
      </a>
      <span className="text-sky-600 mx-1.5">·</span>
      <a
        href="https://www.opera360hr.com"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="brand-bar-hr-link"
        className="text-sky-600 hover:text-white transition-colors"
      >
        OPERA360 HR
      </a>
    </p>
  </div>
);
